export default {"src":"/_next/static/media/hero.0bbba94c.svg","height":178,"width":219,"blurWidth":0,"blurHeight":0};